import React from 'react';

import styled from 'styled-components';
import { StyledTypography } from 'styles/common';

import { getPercentileColor } from 'constants/helper';

function getDividerColor(left, score) {
  left = Number(left);
  score = Number(score);
  return left < score ? '#eee' : '#ddd';
}

export default function ScoreBar({
  score,
  benchmarkValue,
  color,
  showBenchmark,
  showBenchmarkText = false,
  dividerWidth,
  height,
  width,
}) {
  function buildBar() {
    let tempScore = score;
    const barsList = [];
    barsList.push(<BarPart width={`${tempScore}%`} color={color} />);
    tempScore = 100 - tempScore;
    if (tempScore > 0) barsList.push(<BarPart width={`${tempScore}%`} />);
    return barsList;
  }

  if (!color) {
    color = getPercentileColor(score);
  }

  return (
    <Container height={height} width={width}>
      <BarContainer>
        {buildBar()}
        <Divider left="25" score={score} />
        <Divider left="50" score={score} />
        <Divider left="75" score={score} />
      </BarContainer>
      {showBenchmark && <Benchmark left={benchmarkValue} />}
      {showBenchmarkText && (
        <BenchmarkText variant="body2" left={benchmarkValue}>
          Benchmark
        </BenchmarkText>
      )}
    </Container>
  );
}

ScoreBar.defaultProps = {
  score: 0,
  benchmarkValue: 0,
  color: null,
  showBenchmark: true,
  dividerWidth: 1,
  // height: '50px',
  height: '35px',
  width: '100%',
};

const BarPart = styled.div`
  display: inline-block;
  height: 100%;
  width: ${(props) => props.width};
  background-color: ${(props) => props.color || '#F2F1F5'};
  border-radius: 4px;
`;

const BarContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  // height: 70%;
  height: 100%;
  width: 100%;
`;

const Divider = styled.div`
  position: absolute;
  height: 100%;
  width: 4px;
  background-color: white;
  // background-color: ${({ left, score }) => getDividerColor(left, score)};
  top: 0;
  z-index: 2;
  left: ${(props) => props.left}%;
`;

const Benchmark = styled.div`
  position: absolute;
  height: 100%;
  opacity: 0.7;
  width: 2px;
  border-left: 1px dashed rgba(0, 0, 0, 0.5);
  border-right: 1px dashed rgba(0, 0, 0, 0.5);
  top: 0;
  z-index: 2;
  left: ${(props) => props.left}%;
`;

const BenchmarkText = styled(StyledTypography)`
  font-weight: normal;
  position: absolute;
  opacity: 0.7;
  bottom: -20px;
  z-index: 2;
  left: ${(props) => props.left - 4}%;
  display: inline;
`;

const Container = styled.div`
  height: ${(props) => props.height};
  width: ${(props) => props.width};
  display: flex;
  align-items: center;
  position: relative;
`;
